import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPatientJourney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m23 3.75 4.6 3.45-1.2 1.6L24 7v7c0 1.818-1.036 2.92-2.8 2.996L21 17H10c-.735 0-.972.194-.998.868L9 18v2.126A4.002 4.002 0 0 1 8 28a4 4 0 0 1-1-7.874V18c0-1.818 1.036-2.92 2.8-2.996L10 15h11c.735 0 .972-.194.998-.868L22 14V7l-2.4 1.8-1.2-1.6L23 3.75Zm3.293 16.543 1.414 1.414L25.415 24l2.292 2.293-1.414 1.414L24 25.415l-2.293 2.292-1.414-1.414L22.585 24l-2.292-2.293 1.414-1.414L24 22.585l2.293-2.292ZM8 22a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm3.22-17.625 1.56 1.25-4.572 5.716-3.763-2.509 1.11-1.664 2.237 1.491 3.427-4.284Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcPatientJourney;
